export default __webpack_public_path__ + "static/1600-e355e22f379d839c88a59307022de952.gif";